var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.selected ? 'selected' : '',staticStyle:{"margin":"3px 0 2px 0","overflow-y":"hidden","overflow-x":"hidden"}},[_c('div',{staticStyle:{"line-height":"1"}},[_vm._v(" "+_vm._s(_vm.node.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }